import { useEffect, useRef } from 'react';
import { useReduxState } from 'hooks';
import { Checkbox, Form, FormGroup } from 'components/common/form';

import type { FormApi } from 'informed';

interface Props {
  blockId: number;
  data: { showResponseRatesAfterSubmit?: boolean };
  disabled?: boolean;
  onShowResponseRatesAfterSubmitChange: (value: boolean) => void;
}

const EditorBlockChoiceTasksResponseRates = ({
  blockId,
  data,
  disabled,
  onShowResponseRatesAfterSubmitChange
}: Props) => {
  const formApiRef = useRef<FormApi>(undefined);

  const { messages } = useReduxState();

  const setFormApi = (api: FormApi) => {
    formApiRef.current = api;
  };

  useEffect(() => {
    if (formApiRef.current) {
      const { showResponseRatesAfterSubmit } =
        formApiRef.current.getState().values;
      if (data.showResponseRatesAfterSubmit !== showResponseRatesAfterSubmit) {
        formApiRef.current.setValue(
          'showResponseRatesAfterSubmit',
          data.showResponseRatesAfterSubmit
        );
      }
    }
  }, [data.showResponseRatesAfterSubmit]);

  return (
    <FormGroup label={messages.editorBlockCommonResponseData} maxWidth="100%">
      <Form getApi={setFormApi}>
        <Checkbox
          disabled={disabled}
          field="showResponseRatesAfterSubmit"
          id={`show-response-rates-after-submit-${blockId}`}
          initialValue={data.showResponseRatesAfterSubmit}
          label={messages.editorBlockCommonResponseDataShow}
          onValueChange={onShowResponseRatesAfterSubmitChange}
        />
      </Form>
    </FormGroup>
  );
};

export default EditorBlockChoiceTasksResponseRates;
